import React, { FC, PropsWithChildren } from 'react';

import { BaseInformationStep, BaseInformationStepProps } from './base-information-step';
import { StyledContentPlaceholder } from './information-step.styled';

export const InformationStep: FC<PropsWithChildren<BaseInformationStepProps>> = (props) => {
  const { children, loading, ...rest } = props;

  return (
    <BaseInformationStep {...rest} loading={loading}>
      {loading ? <StyledContentPlaceholder numberOfRows={2} hasTitle={true} /> : children}
    </BaseInformationStep>
  );
};
